// components/season/SeasonTeams.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function SeasonTeams() {
  const { seasonId } = useParams(); // Get seasonId from the URL
  const [teams, setTeams] = useState([]);
  const [seasonName, setSeasonName] = useState('');
  const [leagueName, setLeagueName] = useState('');

  useEffect(() => {

    axios
      .get(`/api/leagues/seasons/${seasonId}/details/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      })
      .then((response) => {
        setSeasonName(response.data.name); // Set the season name
        setLeagueName(response.data.league_name); // Set the league name
      })
      .catch((error) => {
        console.error('Error fetching season details:', error);
        alert('Unable to fetch season details.');
      });

    // Fetch teams for the season
    axios
      .get(`/api/teams/${seasonId}/teams/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      })
      .then((response) => setTeams(response.data))
      .catch((error) => {
        console.error('Error fetching teams:', error);
        alert('Unable to fetch teams.');
      });
  }, [seasonId]);

  return (
    <div className="container">
      <div className="card p-4">
        <div className="card-header d-sm-flex align-items-center text-center justify-content-sm-between border-0 pb-0">
          <h2 className="h4 card-title">Teams for {leagueName} {seasonName}</h2>
          <button className="btn btn-primary-soft" data-bs-toggle="modal" data-bs-target="#modalCreateEvents"> <i className="fa-solid fa-plus pe-1"></i> add Team</button>
        </div>
        <div className="card-body">
          <div className="row g-4">
            {teams.map((team) => (
              <div key={team.id} className="col-sm-6 col-xl-4">
                <div className="card h-100">
                  <div className="position-relative">
                    <img
                      className="img-fluid rounded-top"
                      src={team.logo || `${process.env.PUBLIC_URL}/images/default_team_logo.png`}
                      alt={`${team.name} logo`}
                      style={{
                        width: '200px',
                        height: '200px',
                        objectFit: 'cover',
                        margin: 'auto',
                        display: 'block',
                      }}
                    />
                  </div>
                  <div className="card-body position-relative pt-0">
                    <h6 className="mt-3">{team.name}</h6>
                    <p className="mb-0 small">
                      <i className="bi bi-trophy pe-1"></i> Wins: {team.wins}
                    </p>
                    <p className="small">
                      <i className="bi bi-trophy-fill pe-1"></i> Losses: {team.losses}
                    </p>
                    <p className="small">
                      <i className="bi bi-trophy-fill pe-1"></i> Draws: {team.draws}
                    </p>
                    <p className="small">
                      <i className="bi bi-person pe-1"></i> Captain: {team.captain}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SeasonTeams;
